import "./App.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "animate.css";
import Base from "./Base";
import ExperiencePage from "./Section/2_A_propos/Experiences/Experiences.jsx";
import loisirs from "./Section/2_A_propos/Loisirs/Loisirs.jsx";
import portfolioDetail from "./Section/5_Portfolio/detail/portfolio_detail.jsx";

import secret_santa from "./Projets/Secret Santa/secret_santa.jsx";

import QRCodeGenerator from "./Projets/QrCode/qrCode";
import MentionsLegales from "./Section/Mentions Légales/mention_legales.jsx";

import { BrowserRouter, Route, Routes } from "react-router-dom";

export default function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/*" Component={Base} />
          <Route path="/experiences" Component={ExperiencePage} />
          <Route path="/loisirs" Component={loisirs} />
          <Route path="/portfolio/:id" Component={portfolioDetail} />
          <Route path="/secret-santa" Component={secret_santa} />
          <Route path="/qr-code" Component={QRCodeGenerator} />
          <Route path="/mentions-legales" Component={MentionsLegales} />
        </Routes>
      </BrowserRouter>
      <ToastContainer />
    </>
  );
}
